import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'harmony-cookies-consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Petit délai pour ne pas gêner le rendu initial
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, date: Date.now() }));
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, date: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[100] bg-[#332724] text-[#FDFAF4] rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.35)] p-6 border border-[#B8922A]/40"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Bandeau de consentement cookies"
    >
      <p
        className="text-lg mb-2 text-[#B8922A]"
        style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
      >
        Cookies & confidentialité
      </p>
      <p className="text-sm font-light text-[#FDFAF4]/90 leading-relaxed mb-4">
        Nous utilisons uniquement les cookies strictement nécessaires au bon fonctionnement
        du site. Aucun traceur publicitaire n'est déposé sans votre accord.
      </p>
      <div className="flex flex-wrap gap-2 mb-3">
        <button
          onClick={accept}
          className="flex-1 bg-[#B8922A] hover:bg-[#9a7922] text-[#FDFAF4] px-4 py-2 rounded-full text-xs uppercase tracking-[0.18em] transition-colors"
          data-testid="cookie-accept"
        >
          J'accepte
        </button>
        <button
          onClick={refuse}
          className="flex-1 bg-transparent border border-[#FDFAF4]/30 hover:border-[#FDFAF4] text-[#FDFAF4] px-4 py-2 rounded-full text-xs uppercase tracking-[0.18em] transition-colors"
          data-testid="cookie-refuse"
        >
          Refuser
        </button>
      </div>
      <Link
        to="/confidentialite"
        onClick={() => setVisible(false)}
        className="text-xs text-[#B8922A] hover:text-[#FDFAF4] underline underline-offset-2 transition-colors"
      >
        En savoir plus sur notre politique de confidentialité
      </Link>
    </div>
  );
};

export default CookieBanner;
